import { render, staticRenderFns } from "./WorkOpinionDrawer.vue?vue&type=template&id=a8c4b5ac&scoped=true&"
import script from "./WorkOpinionDrawer.vue?vue&type=script&lang=js&"
export * from "./WorkOpinionDrawer.vue?vue&type=script&lang=js&"
import style0 from "./WorkOpinionDrawer.vue?vue&type=style&index=0&id=a8c4b5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c4b5ac",
  null
  
)

export default component.exports